var selectedColor;
var selectedGrade;
var selectedFabric;
var selectedSeries;
var selectedSpecial; // ✅ new
var EleHeight;
var itemCount;

class americanSwatch {
  constructor(){
    const radioButtonsColor = document.querySelectorAll('[data_color]');
    const radioButtonsGrade = document.querySelectorAll('[data_grade]');
    const radioButtonsSeries = document.querySelectorAll('[data_series]');
    const radioButtonsFabric = document.querySelectorAll('[data_fabric]');
    const radioButtonsSpecial = document.querySelectorAll('[data_special]'); // ✅ new
    const gridItems = document.querySelectorAll('[data-swatch-item]');
    itemCount = document.querySelectorAll('[data-swatch-item]').length;
    EleHeight = document.querySelectorAll("[data-swatch-item]")[1].querySelector(".swatch-more-wrapper").offsetHeight;

    document.querySelectorAll("[data-swatch-item]")[0].querySelector("[swatch_detials]").style.height = `${EleHeight}px`

    console.log("EleHeight",EleHeight)

    radioButtonsColor.forEach(ele=>{
        ele.addEventListener("change",(event)=>{
            this._colorChange(event);
        })
    });

    radioButtonsFabric.forEach(ele=>{
        ele.addEventListener("change",(event)=>{
            this._fabricChange(event);
        })
    });

    radioButtonsGrade.forEach(ele=>{
        ele.addEventListener("change",(event)=>{
            this._gradeChange(event);
        })
    });

    radioButtonsSeries.forEach(ele=>{
        ele.addEventListener("change",(event)=>{
            this._seriesChange(event);
        })
    });

    // ✅ new special features event listener
    radioButtonsSpecial.forEach(ele=>{
        ele.addEventListener("change",(event)=>{
            this._specialChange(event);
        })
    });

    gridItems.forEach(ele=>{
        ele.addEventListener("click",(event)=>{
            this._showItemDetials(event);
        })
    });
    
  }

  _colorChange(event){
     if (event.target.checked) {
       selectedColor = event.target.value;
       this._loadSwatchGrid();
      }
  }

   _fabricChange(event){
     if (event.target.checked) {
       selectedFabric = event.target.value;
       this._loadSwatchGrid();
      }
   }

   _gradeChange(event){
     if (event.target.checked) {
       selectedGrade = event.target.value;
       this._loadSwatchGrid();
      }
   }

   _seriesChange(event){
     if (event.target.checked) {
       selectedSeries = event.target.value;
       this._loadSwatchGrid();
      }
   }

   // ✅ new method for special_features
   _specialChange(event){
     if (event.target.checked) {
       selectedSpecial = event.target.value;


       console.log('selectedSpecial', selectedSpecial)
       this._loadSwatchGrid();
      }
   }

  _loadSwatchGrid(){
    const gridElements = document.querySelectorAll('[data-swatch-details]');
    let hiddenCount = 0;

    gridElements.forEach(ele => {
      const scriptContent = ele.textContent;
      const data = JSON.parse(scriptContent);

      let itemFound = data.some(item => {
        // AND condition across filters:
        if (selectedColor && !item.color.includes(selectedColor)) return false;
        if (selectedFabric && !item.fabric_type.includes(selectedFabric)) return false;
        if (selectedGrade && !item.grade.includes(selectedGrade)) return false;
        if (selectedSeries && !item.series.includes(selectedSeries)) return false;
        if (selectedSpecial && !item.special_features.includes(selectedSpecial)) return false; // ✅ new
        return true;
      });

      if (!itemFound) {
        ele.closest("[data-swatch-item]").classList.add("d-none");
        hiddenCount++;
      } else {
        ele.closest("[data-swatch-item]").classList.remove("d-none");
      }
    });

    document.querySelector("[empty-search]").classList.toggle("d-none", hiddenCount !== itemCount);
  }


  _showItemDetials(event){
    let currentEle = event.currentTarget;
    
    document.querySelectorAll('[data-swatch-item]').forEach(ele=>{
      ele.classList.remove("active");
      ele.querySelector(".image_wrapper").classList.remove("active");
      ele.querySelector("[swatch_detials]").removeAttribute('style')
    });
    
    currentEle.classList.add("active");
    currentEle.querySelector(".image_wrapper").classList.add("active");
    currentEle.querySelector("[swatch_detials]").style.height = `${EleHeight}px`
    
  }

}

new americanSwatch()
